import classNames from 'classnames';
import { MaskedInput } from "react-text-mask-modern";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { BaseFieldProps, InputField } from './InputField';
import { formatUtils, numericUtils } from '../../../utils';

interface Props extends BaseFieldProps {
    includeThousandsSeparator?: boolean;
    integerLimit?: number;
    decimalLimit?: number;
    allowNegative?: boolean;
    allowDecimal?: boolean;
    autoFormat?: boolean;
    readOnly?: boolean;
    onBlur?: () => void;
}

export const NumberField = ({ includeThousandsSeparator = true, integerLimit, decimalLimit = 2, autoFormat = false, readOnly = false, allowNegative = false, allowDecimal = true, onBlur, ...props }: Props) => {
    return (
        <InputField {...props} renderElement={(formik, field, meta, helpers) => {
            const withError = meta.touched && meta.error;
            return (
            <div className="data-item-col">
                <MaskedInput
                    {...field}
                    className={classNames('form-control', 'text-right', { 'is-invalid': withError })}
                    mask={createNumberMask({
                        prefix: '',
                        allowDecimal: allowDecimal,
                        allowNegative: allowNegative,
                        decimalLimit,
                        includeThousandsSeparator,
                        integerLimit,
                    })}
                    guide={false}
                    value={field.value || ''}
                    onChange={e => helpers.setValue(e.target.value)}
                    onBlur={e => {
                        field.onBlur(e);
                        if (autoFormat) {
                            const raw = String(field.value ?? '').replace(/,/g, '');
                            if (raw !== '' && numericUtils.isNumber(raw)) {
                                helpers.setValue(formatUtils.formatDecimal(Number(raw), decimalLimit));
                            }
                        }
                        onBlur?.();
                    }}
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    readOnly={readOnly}
                />
                {withError && <div className="form-error">{meta.error}</div>}
            </div>
            );
        }} />
    );
}
